var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"clear-input",on:{"click":function($event){return _vm.$emit('clear-input-field')}}},[_c('IconClear')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }